import { deleteAuthCookies } from 'src/utils/cookies';
import { UserRepository } from '../repositories/UserRepository';

export class UserService {
  private userRepository = new UserRepository();

  public async fetch() {
    const user = await this.userRepository.fetchUser();

    if (user) {
      return user;
    }
  }

  public async signOut() {
    this.userRepository.delete();
    window.sessionStorage.clear();
    deleteAuthCookies();
  }
}
